<template>
  <tr v-if="prices">
    <th class="sheet-header text-truncate text-capitalize font-weight-regular" style="border-left: 2px solid white">
      <v-row align="center" no-gutters>
        <v-icon x-small class="mx-1 mr-2">mdi-help-circle-outline</v-icon>
        Stop Sell
      </v-row>
    </th>
    <td class="sheet-cell text-center pa-0" v-for="(price, index) in prices" :key="index">
      <v-progress-circular v-if="price.ssu" size="12" width="2" indeterminate/>
      <v-btn v-else @click="update(price)" text block tile height="30" :ripple="false">
        <v-icon x-large style="line-height: 0;" v-text="price.stop_sell ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'" :color="price.stop_sell ? 'red' : 'grey darken-1'"/>
      </v-btn>
    </td>
  </tr>
</template>


<script>

  import sheet_repository from "@/repositories/sheet-repository";

  export default {
    props: {
      prices: null
    },

    methods: {
      async update(data) {
        try {
          this.$set(data, 'ssu', true);
          this.$set(data, 'stop_sell', !data.stop_sell);
          await sheet_repository.updatePrice(data);
        } catch (error) {
        } finally {
          this.$set(data, 'ssu', false);
        }
      }
    }

  }
</script>


<style scoped>
  @import '../sheet.css';
</style>